<div class="row align-items-center" (click)="closeDropDown()">
  <div class="col-md-12">

    <div #menu class="d-flex justify-content-between w-100 location-selector-form"
      [ngClass]="{'disableSelector':selectorDisabled,'location-selector-focus' : selectorOpened}" id="ddlLocationy"
      (click)="locationClick()" (click)="$event.stopPropagation()" [title]="hoverText">
      <div>{{selectedUserName}}</div>
      <div><em class="fas fa-chevron-down"></em></div>
    </div>
    <div class="location-tree-wrapper p-2" *ngIf="selectorOpened" (click)="$event.stopPropagation()">
      <user-selector-tree-view [locations]="locations" [expandedKeys]="expandedKeys" [selectedUserId]="selectedUserId"
        (closeEvent)="onItemSelected($event)" [dispatchStateEvent]="dispatchStateEvent">
      </user-selector-tree-view>
    </div>
  </div>
</div>